$(document).ready(function() {
  $('.gallery_img_slide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.custom-prev'),
    nextArrow: $('.custom-next'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '60px'
        }
      }
    ]
  });
});

$(document).ready(function () {
  if ($(window).width() <= 700) {
    $(".footer-title-div").click(function () {
      console.log("click");
      $(this).parent().siblings().find(".footer-menu-div").slideUp();
      $(this).parent().siblings().removeClass("active");
      $(this).parent().toggleClass("active");
      $(this).next().slideToggle();
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const productGrids = document.querySelectorAll(".feature_slide,.product-grid");

  productGrids.forEach(grid => {
    const wrapper = grid.closest(".product-grid-wrapper,.feature_collection_product_list");
    const arrowContainer = wrapper.querySelector(".collection-custome-arrow");

    if (!grid.classList.contains("slick-initialized")) {
      $(grid).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 400,
        appendArrows: $(arrowContainer),
        prevArrow: '<button type="button" class="slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none"><path d="M5.5 1L1 5.5L5.5 10" stroke="white"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M1 1L5.5 5.5L1 10" stroke="white"/></svg></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: { slidesToShow: 3 }
          },
          {
            breakpoint: 992,
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '147px'
            }
          }
        ]
      });
    }
  });
});



  // Progress bar logic
$(document).on('beforeChange', '.product-grid,.feature_slide', function (event, slick, currentSlide, nextSlide) {
  const $progressBar = $(this).closest('.product-grid-wrapper,.feature_collection_product_list').find('.progress-bar');
  const $label = $(this).closest('.product-grid-wrapper,.feature_collection_product_list').find('.slider__label');

  const calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

  $progressBar
    .css('width', calc + '%')   // ✅ updated line: sets width, not background-size
    .attr('aria-valuenow', calc);

  $label.text(calc.toFixed(0) + '% completed');
});



$(document).ready(function() {

    
  $('.trustpilot_inner_slide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.trustpilot_custom_prev'),
    nextArrow: $('.trustpilot_custom_next'),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});


$(document).ready(function() {
  $('.pts_inner_slide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.trustpilot_custom_prev'),
    nextArrow: $('.trustpilot_custom_next'),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '97px'
        }
      },
      {
        breakpoint: 370,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '50px'
        }
      }
    ]
  });
});

$(document).ready(function() {
  $('.home-product-grid').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '147px'
        }
      }
    ]
  });
});

$(document).ready(function() {
  const $grid = $('.featured-product-grid');
  const $progressBar = $('.featured-progress-bar');
  const $arrowContainer = $('.featured-collection-custome-arrow');

  $grid.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
    let i = (currentSlide ? currentSlide : 0) + 1;
    const total = slick.slideCount;
    const progress = (i / total) * 100;
    $progressBar.css('width', progress + '%');
  });

  $grid.slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    appendArrows: $arrowContainer,
    prevArrow: '<button type="button" class="slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 12L3.64645 11.6464L3.29289 12L3.64645 12.3536L4 12ZM19 12.5C19.2761 12.5 19.5 12.2761 19.5 12C19.5 11.7239 19.2761 11.5 19 11.5V12.5ZM9.64645 5.64645L3.64645 11.6464L4.35355 12.3536L10.3536 6.35355L9.64645 5.64645ZM3.64645 12.3536L9.64645 18.3536L10.3536 17.6464L4.35355 11.6464L3.64645 12.3536ZM4 12.5H19V11.5H4V12.5Z" fill="black"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 12L20.3536 11.6464L20.7071 12L20.3536 12.3536L20 12ZM5 12.5C4.72386 12.5 4.5 12.2761 4.5 12C4.5 11.7239 4.72386 11.5 5 11.5V12.5ZM14.3536 5.64645L20.3536 11.6464L19.6464 12.3536L13.6464 6.35355L14.3536 5.64645ZM20.3536 12.3536L14.3536 18.3536L13.6464 17.6464L19.6464 11.6464L20.3536 12.3536ZM20 12.5H5V11.5H20V12.5Z" fill="black"/></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '147px'
        }
      }
    ]
  });
});



jQuery('.product_sec .product-info__block-list .product-info__block-item[data-block-type="description"] .prose').readmore({
    speed: 300,
    collapsedHeight: 136,
    moreLink: '<a href="#"><svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 4.25L8.5 12.75" stroke="black" stroke-width="0.708333" stroke-linecap="square" stroke-linejoin="round"/><path d="M12.75 8.5L4.25 8.5" stroke="black" stroke-width="0.708333" stroke-linecap="square" stroke-linejoin="round"/></svg> Read more </a>',
    lessLink: '<a href="#"><svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.75 8.5L4.25 8.5" stroke="black" stroke-width="0.708333" stroke-linecap="square" stroke-linejoin="round"/> </svg> Read less</a>',
    heightMargin: 16
});


document.addEventListener("DOMContentLoaded", function () {
    function updateVariantMetafields(variantId) {
        const metafieldDisplays = document.querySelectorAll(".variante-value-div");
        metafieldDisplays.forEach((el) => el.style.display = "none"); // Hide all initially

        const selectedMetafield = document.querySelector(`.variante-value-div[data-variant-id="${variantId}"]`);
        if (selectedMetafield) {
            selectedMetafield.style.display = "block"; // Show only the selected variant's metafield
        }
    }

    function getSelectedVariantId() {
        const variantSelector = document.querySelector("[name='id']");
        return variantSelector ? variantSelector.value : null;
    }

    // Run on page load
    const initialVariantId = getSelectedVariantId();
    if (initialVariantId) {
        updateVariantMetafields(initialVariantId);
    }

    // Update on variant change
    const variantDropdown = document.querySelector("[name='id']");
    if (variantDropdown) {
        variantDropdown.addEventListener("change", function () {
            updateVariantMetafields(this.value);
        });
    }
});


// function updateCountdown() {
//   const messageEl = document.getElementById("countdown-message");
//   const now = new Date();
//   const danishNow = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Copenhagen" }));

//   const cutoff = new Date(danishNow);
//   cutoff.setHours(15, 0, 0, 0); // 15:00:00

//   // Get the date 4 days from now
//   const futureDate = new Date(danishNow);
//   futureDate.setDate(futureDate.getDate() + 5);
//   const formattedFutureDate = futureDate.toLocaleDateString("en-GB", {
//     day: "numeric",
//     month: "long",
//     year: "numeric"
//   });

//   if (danishNow < cutoff) {
//     const diff = cutoff - danishNow;
//     const hours = Math.floor(diff / (1000 * 60 * 60));
//     const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

//     messageEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" style="width: 12px; height: 12px;" width="1em" height="1em" viewBox="0 0 24 24"><g><g><path d="M12,24C5.383,24,0,18.617,0,12S5.383,0,12,0s12,5.383,12,12-5.383,12-12,12ZM12,1.412C6.162,1.412,1.412,6.162,1.412,12s4.75,10.588,10.588,10.588,10.588-4.75,10.588-10.588S17.838,1.412,12,1.412Z" style="fill:#1a1a1a;"></path><path d="M15.31,16.016c-.181,0-.361-.069-.499-.207l-3.31-3.31c-.132-.132-.207-.312-.207-.499V5.9c0-.39,.316-.706,.706-.706s.706,.316,.706,.706v5.808l3.103,3.103c.276,.276,.276,.722,0,.998-.138,.138-.318,.207-.499,.207Z" style="fill:#1a1a1a;"></path></g></g></svg> Order Within <strong>${hours} Hour ${minutes} Mins </strong> to receive before <strong>${formattedFutureDate}</strong>.`;
//   } else {
//     messageEl.innerHTML = `order now to receive before <strong>${formattedFutureDate}</strong>.`;
//   }
// }

// setInterval(updateCountdown, 1000);
// updateCountdown();


$(document).on('click', '.block-swatch', function() {
  $('.in-stock-out').show();
  $('.main-in-stock-out').hide();

  if ($(this).hasClass('is-disabled')) {
    console.log('Out of stock clicked');
    $('.in_stock').hide();
    $('.payment_stock_avalablity').addClass('pay_out_stock');
    $('.out_of_stock').show();
    $('.in_stock_msg').hide();
  } else {
    console.log('In stock clicked');
    $('.in_stock').show();
    $('.payment_stock_avalablity').removeClass('pay_out_stock');
    $('.in_stock_msg').show();
    $('.out_of_stock').hide();
  }
});


